import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { esqueciSenha } from '../../api';

/* ─── Floating orb decoration ─── */
function Orb({ size, top, left, opacity, delay }) {
  return (
    <div
      style={{
        position: 'absolute',
        width: size,
        height: size,
        top,
        left,
        opacity,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.18) 0%, transparent 70%)',
        animation: `float 6s ease-in-out ${delay} infinite alternate`,
        pointerEvents: 'none',
      }}
    />
  );
}

function GridLines() {
  return (
    <svg
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0.06 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.8" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  );
}

export default function EsqueciSenha() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await esqueciSenha(email);
      setEnviado(true);
    } catch (err) {
      setError(err.message || 'Erro inesperado. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@300;400;500;600&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Sans', sans-serif; }

        @keyframes float {
          from { transform: translateY(0px) scale(1); }
          to   { transform: translateY(-24px) scale(1.06); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(32px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes successPop {
          0%   { opacity: 0; transform: scale(0.85) translateY(12px); }
          60%  { transform: scale(1.03) translateY(-2px); }
          100% { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes spin { to { transform: rotate(360deg); } }

        .esq-root { display: flex; min-height: 100vh; font-family: 'DM Sans', sans-serif; }

        .left-panel {
          position: relative;
          overflow: hidden;
          flex: 1;
          display: none;
          flex-direction: column;
          justify-content: space-between;
          padding: 48px;
          background: linear-gradient(145deg, #3b0764 0%, #6b21a8 40%, #9d174d 100%);
          color: white;
        }
        @media (min-width: 900px) { .left-panel { display: flex; } }

        .left-logo {
          font-weight: 600; font-size: 1.25rem; letter-spacing: 0.04em;
          display: flex; align-items: center; gap: 8px;
          animation: fadeUp 0.5s ease both;
        }
        .left-logo span { font-weight: 300; opacity: 0.8; }

        .left-hero { animation: fadeUp 0.7s 0.2s ease both; opacity: 0; }
        .left-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2rem, 3.5vw, 3rem);
          line-height: 1.15;
          margin-bottom: 16px;
        }
        .left-hero p { font-size: 0.95rem; opacity: 0.7; line-height: 1.6; max-width: 340px; }

        .right-panel {
          display: flex; align-items: center; justify-content: center;
          padding: 32px 24px; background: #fafafa; flex: none; width: 100%;
        }
        @media (min-width: 900px) { .right-panel { width: 440px; } }

        .form-card { width: 100%; max-width: 380px; animation: slideIn 0.6s 0.1s ease both; opacity: 0; }

        .form-title { font-family: 'Playfair Display', serif; font-size: 2rem; color: #1a1a2e; margin-bottom: 6px; }
        .form-subtitle { font-size: 0.875rem; color: #6b7280; margin-bottom: 32px; line-height: 1.5; }

        .field { margin-bottom: 20px; }
        .field label {
          display: block; font-size: 0.8rem; font-weight: 500; color: #374151;
          margin-bottom: 6px; letter-spacing: 0.02em;
        }
        .field input {
          width: 100%; padding: 12px 16px; border: 1.5px solid #e5e7eb; border-radius: 10px;
          font-family: 'DM Sans', sans-serif; font-size: 0.9rem; color: #111; background: white;
          transition: border-color 0.2s, box-shadow 0.2s; outline: none;
        }
        .field input:focus { border-color: #9d174d; box-shadow: 0 0 0 3px rgba(157,23,77,0.1); }
        .field input:disabled { opacity: 0.6; cursor: not-allowed; }

        .error-box {
          background: #fff1f2; border: 1px solid #fecdd3; color: #be123c; font-size: 0.82rem;
          padding: 10px 14px; border-radius: 8px; margin-bottom: 16px;
          display: flex; align-items: center; gap: 8px;
        }

        .btn-primary {
          width: 100%; padding: 13px; border: none; border-radius: 10px;
          background: linear-gradient(135deg, #3b0764 0%, #9d174d 100%); color: white;
          font-family: 'DM Sans', sans-serif; font-size: 0.9rem; font-weight: 600; cursor: pointer;
          letter-spacing: 0.03em; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
          box-shadow: 0 4px 14px rgba(157,23,77,0.35); margin-bottom: 12px;
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .btn-primary:hover:not(:disabled) { opacity: 0.92; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(157,23,77,0.45); }
        .btn-primary:active:not(:disabled) { transform: translateY(0); }
        .btn-primary:disabled { opacity: 0.55; cursor: not-allowed; }

        .spinner {
          width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.35);
          border-top-color: white; border-radius: 50%; animation: spin 0.7s linear infinite;
        }

        .btn-secondary {
          width: 100%; padding: 12px; border: 1.5px solid #e5e7eb; border-radius: 10px;
          background: white; color: #374151; font-family: 'DM Sans', sans-serif;
          font-size: 0.875rem; font-weight: 500; cursor: pointer;
          transition: border-color 0.2s, background 0.2s, color 0.2s;
        }
        .btn-secondary:hover { border-color: #9d174d; color: #9d174d; background: #fff1f2; }

        .footer-note { text-align: center; font-size: 0.72rem; color: #9ca3af; margin-top: 28px; }

        .success-card { width: 100%; max-width: 380px; text-align: center; animation: successPop 0.55s ease both; }
        .success-icon-wrap {
          width: 72px; height: 72px; border-radius: 50%;
          background: linear-gradient(135deg, #3b0764, #9d174d);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 20px; box-shadow: 0 8px 24px rgba(157,23,77,0.35);
        }
        .success-title { font-family: 'Playfair Display', serif; font-size: 1.75rem; color: #1a1a2e; margin-bottom: 8px; }
        .success-subtitle { font-size: 0.875rem; color: #6b7280; line-height: 1.6; margin-bottom: 24px; }
      `}</style>

      <div className="esq-root">
        {/* ══ LEFT PANEL ══ */}
        <div className="left-panel">
          <GridLines />
          <Orb size="320px" top="-80px" left="-80px" opacity={0.5} delay="0s" />
          <Orb size="200px" top="40%" left="60%" opacity={0.3} delay="2s" />
          <Orb size="140px" top="70%" left="-20px" opacity={0.25} delay="1s" />

          <div className="left-logo">
            <strong>YOUX</strong>
            <span>GROUP</span>
          </div>

          <div className="left-hero">
            <h1>Esqueceu sua<br />senha? Sem<br />problemas.</h1>
            <p>
              Informe seu e-mail cadastrado e enviaremos um link seguro para você redefinir sua senha.
            </p>
          </div>

          <div />
        </div>

        {/* ══ RIGHT PANEL ══ */}
        <div className="right-panel">
          {enviado ? (
            <div className="success-card">
              <div className="success-icon-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="success-title">Verifique seu e-mail</h2>
              <p className="success-subtitle">
                Se o endereço <strong>{email}</strong> estiver cadastrado, você receberá em instantes
                um link para redefinir sua senha. O link expira em 30 minutos.
              </p>
              <button className="btn-primary" onClick={() => navigate('/')}>
                Voltar para o Login
              </button>
            </div>
          ) : (
            <div className="form-card">
              <h2 className="form-title">Recuperar senha</h2>
              <p className="form-subtitle">Informe seu e-mail para receber o link de redefinição.</p>

              <form onSubmit={handleSubmit}>
                <div className="field">
                  <label>E-mail</label>
                  <input
                    type="email"
                    placeholder="seu.email@youxgroup.com.br"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    required
                  />
                </div>

                {error && (
                  <div className="error-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    {error}
                  </div>
                )}

                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? (<><div className="spinner" /> Enviando...</>) : 'Enviar link de recuperação'}
                </button>

                <button type="button" className="btn-secondary" onClick={() => navigate('/')}>
                  Voltar para o Login
                </button>
              </form>

              <p className="footer-note">
                © {new Date().getFullYear()} Youx Group · Acesso restrito
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
